import React, { useState } from 'react'
import Modal from 'react-responsive-modal'
import { useDispatch } from 'react-redux'
import styles from './styles.module.css'
import { useFormik } from 'formik'
import { Checkbox, Input } from '../../components/ModalInputs'
import * as Yup from 'yup'
import ModalFooter from '../../components/ModalFooter/ModalFooter'
import { SketchPicker } from 'react-color'
import { createTvProgramType, updateTvProgramType } from '../../actions/tvProgramType copy.js'
import { createTvProgramSchedule, updateTvProgramSchedule } from '../../actions/tvProgramSchedule copy.js'

const validationSchema = Yup.object({
  name: Yup.string().required('обязательное поле').max(30, 'Должно быть не более 30 символов'),

})

export default function ModalComponent({ data, closeModal, height, addMode, handleChangeRow, arrValuesName }) {

  const getColor = (newcolor) => {  // ВЫНИМАЮ ЦВЕТ ИЗ ПАЛИТРЫ
    setFieldValue('color', newcolor.hex.slice(1))
  }

  const dispatch = useDispatch()

  const handleCreate = (values) => {
    closeModal()
  }

  const handleUpdate = (values) => {
    closeModal()
  }

  const {
    values,
    errors,
    touched,
    submitCount,
    handleChange,
    handleSubmit,
    setFieldValue
  } = useFormik({
    initialValues: addMode ? {} : data,
    enableReinitialize: true,
    // validateOnChange: true,
    // validationSchema: validationSchema,
    onSubmit: addMode ? handleCreate : handleUpdate
  })

  // const error = (fieldName) => (touched[fieldName] || submitCount) && errors[fieldName]

  return (
    !!values &&
    <Modal
      open={!!data}
      onClose={() => false}
      showCloseIcon={false}
      height={height}
      center
      classNames={{
        // overlay: styles.overlay,
        modal: styles.custom
      }}
    >

      <>
        <div>
          <div className={styles.tabWrapper}>
            <div>
              <div>
                <Input
                  label='Название'
                  name='name'
                  value={values?.name}
                  onChange={handleChange}
                  disabled={!addMode}
                />
              </div>
              <br />
              <div>
                <p style={{ color: '#778AAF', fontSize: '13px' }}>Цвет</p>
                <br />
                <SketchPicker name='color' color={values?.color} onChange={getColor} />
              </div>
            </div>
          </div>
        </div>
        <ModalFooter handleSubmit={handleSubmit} closeModal={closeModal} />
      </>
    </Modal>

  )
}
